import httpService from "./httpService";

export type ConfigurationSettingType = "boolean" | "integer" | "string";

export interface SchemaPropertyDescriptor {
  name: string;
  type?: ConfigurationSettingType;
}

export interface UserConfigurationSchemaDescriptor {
  rootLevelProperties: SchemaPropertyDescriptor[];
  userSettingsProperties: SchemaPropertyDescriptor[];
}

export interface UserConfigurationSchema {
  id: number;
  descriptor: UserConfigurationSchemaDescriptor;
  createdAtUtc: string;
  updatedAtUtc: string;
}

interface UserConfigurationSchemaMutationResponse {
  message: string;
  schema: UserConfigurationSchema;
}

export const normalizeConfigurationSettingType = (
  type: unknown
): ConfigurationSettingType => {
  if (type === "integer" || type === "string") return type;
  return "boolean";
};

class UserConfigurationSchemaService {
  private readonly baseUrl = "/v2/admin/user-configuration-schemas";

  async getActiveSchema(): Promise<UserConfigurationSchema> {
    const response = await httpService.get<UserConfigurationSchema>(
      `${this.baseUrl}/active`
    );
    return response.data;
  }

  async getAllSchemas(): Promise<UserConfigurationSchema[]> {
    const response = await httpService.get<UserConfigurationSchema[]>(
      this.baseUrl
    );
    return response.data;
  }

  async createSchema(
    descriptor: UserConfigurationSchemaDescriptor
  ): Promise<UserConfigurationSchema> {
    const response = await httpService.post<UserConfigurationSchemaMutationResponse>(
      this.baseUrl,
      { descriptor }
    );
    return response.data.schema;
  }
}

export const userConfigurationSchemaService = new UserConfigurationSchemaService();
export default userConfigurationSchemaService;
